const socialLoginResult = document.getElementById('formlogin-result-social-login');
const errorResult = document.getElementById('formlogin-error-500');
const result = document.getElementById('formlogin-result');
const resultTooManyAttempts = document.getElementById('formlogin-result-too-many-attempts');
document.addEventListener("DOMContentLoaded", function() {
    new ImaiosForm({
        element: 'formlogin',
        onsubmit: async imaiosForm => {
            socialLoginResult.classList.add('d-none');
            errorResult.classList.add('d-none');
            result.classList.add('d-none');
            resultTooManyAttempts.classList.add('d-none');
            /* Without pow rule, form login make GET request */
            try {
                const response = await fetch(imaiosForm.form.action, imaiosForm.form.options);
                if (response.ok) {
                    const data = await response.text();
                    const objectResponse = JSON.parse(data);
                    if (objectResponse.errors) {
                        result.classList.remove('d-none');
                    } else if (objectResponse.errorTooManyLoginAttempts) {
                        resultTooManyAttempts.classList.remove('d-none');
                    } else if (objectResponse.url) {
                        // add on the session storage the refresh jwt token date
                        window.location = objectResponse.url;
                    }
                }
                else {
                    errorResult.classList.remove('d-none');
                }
            } catch (err) {
                console.log('failure:', imaiosForm.form.action);
                console.error(err);
            }

        },
        onsecurityerror: (err) => {
            errorResult.classList.remove('d-none');
            console.error(err);
        }
    });
    document.getElementById('formlogin').setAttribute('data-imaiosform-initialized', 'true');
});
